import styled from 'styled-components'

export const WrapperCard = styled.div`
  margin-bottom: 16px;
`
